export * from './src/filter-chips.module';
export * from './src/enums';
export * from './src/interface';
